import { TextTooltip } from '@components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const DraftBadge: React.FC = () => {
  const { t } = useTranslation()
  return (
    <TextTooltip tooltip={t('document.draftBadge.tooltip')} placement="bottom-start">
      <StyledBadge>
        <span>{t('document.draftBadge.text')}</span>
      </StyledBadge>
    </TextTooltip>
  )
}

const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  border: 1px solid ${({ theme }) => theme.colors.AIPurple}44;
  padding: ${({ theme }) => `${theme.spacing.xxxs}rem ${theme.spacing.xs}rem`};
  border-radius: 1000px;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.AIPurple};

  svg {
    color: ${({ theme }) => theme.colors.AIPurple};
    width: ${({ theme }) => theme.fontSize.xs}rem;
    height: ${({ theme }) => theme.fontSize.xs}rem;
  }
`
